<template>
  <div>
    <q-form-item
      :label="element.caption"
      :prop="element.key"
    >
      <q-input-number
        v-model.number="model[element.key]"
        :disabled="element.disabled"
        :min="element.min"
        :max="element.max"
      />
    </q-form-item>
  </div>
</template>

<script>
  import elementGeneratorMixin from "./elementGeneratorMixin";

  export default {
    name: "NumberItem",
    mixins: [elementGeneratorMixin],
  }
</script>

<style scoped>

</style>